import { render, staticRenderFns } from "./AppInfoForm.vue?vue&type=template&id=005ad1a4"
import script from "./AppInfoForm.vue?vue&type=script&lang=js"
export * from "./AppInfoForm.vue?vue&type=script&lang=js"
import style0 from "./AppInfoForm.vue?vue&type=style&index=0&id=005ad1a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports